import { useAutoScrollState } from "@/hooks/useAutoScrollState/useAutoScrollState";
import {
  ActiveUtterances,
  RefIntersectionMap,
} from "../ScrollManagerContext.decl";
import {
  isKaraokeOutOfView,
  scrollTo,
} from "../ScrollManagerContext.utilities";

/**
 * The hook responsible for managing the autoScrolling of the transcription.
 * The hook will monitor the activated utterance and will scroll to it if needed.
 * The hook will expose a function to enable manual tracked scrolling.
 * (tracking if active utterance was scrolled out of view).
 * @param intersectionMap
 * @param activeList
 */
export function useAutoScroll(
  intersectionMap: RefIntersectionMap,
  activeList: ActiveUtterances
) {
  const { setAutoScroll, autoScrollEnabled } = useAutoScrollState();

  // show auto scroll button when scrolling active utterance out of view
  const handleOnWheel = () => {
    const outOfView = isKaraokeOutOfView(intersectionMap, activeList);
    setAutoScroll(!outOfView);
  };

  const outOfView = isKaraokeOutOfView(intersectionMap, activeList);
  if (outOfView && autoScrollEnabled) {
    scrollTo(intersectionMap.current.get(activeList[0])?.ref);
  }

  return { handleOnWheel };
}
